export default {
  user: 'Login',
  password: 'Hasło',
  passwordConfirmation: 'Powtórz hasło',
  login: 'Zaloguj się',
  logout: 'Wyloguj się',
  heading: 'Logowanie',
  register: 'Rejestracja',
  registerButton: 'Zarejestruj się',
  confirmEmailHeader: 'Potwierdź adres e-mail',
  confirmEmail: 'Twoje konto nie zostało jeszcze aktywowane. Aby je aktywować, sprawdź skrzynkę e-mail i potwierdź rejestrację.',
  name: 'Imię i nazwisko',
  email: 'Adres e-mail',
  text: 'Platforma Nutricia Copacking stworzona została z myślą o klientach, którzy w szybki i łatwy sposób chcą poznać cenę dla interesującego ich rodzaju przepakowania.',
  forgotPassword: 'Jeśli chcesz odzyskać hasło',
  error: {
    server: 'Wystąpił problem. Spróbuj ponownie później.',
    token: 'Nieprawidłowy token',
    login: 'Dane logowania niepoprawne!',
    email: 'Wpisany e-mail jest niepoprawny!',
    password: 'Pole hasło nie może być puste!',
    passwordConfirmation: 'Hasła nie są identyczne!',
    passwordMinLength: 'Wpisane hasło jest za krótkie!',
    name: 'Wpisane imię i nazwisko są niepoprawne!',
  },
  domainRegister: 'Jeśli masz mail w domenie @danone.com',
  contactAdministrator: 'Jeśli nie masz maila w domenie @danone.com, skontaktuj się z administratorem.',
  backToLogin: 'Wróć do logowania',
  confirmYourEmail: 'Po pomyślnej rejestracji otrzymasz e-mail, który należy potwierdzić, aby aktywować konto.',
  clickHere: 'kliknij tutaj',
  forgotPasswordHeader: 'Odzyskaj hasło',
  forgotPasswordMessage: 'Prośba o zresetowanie hasła została wysłana pomyślnie. Sprawdź pocztę e-mail, aby zresetować hasło.',
  send: 'Wyślij',
  resetPasswordHeader: 'Zresetuj hasło',
  resetPasswordMessage: 'Twoje hasło zostało zmienione pomyślnie.',
  resetPasswordRedirect: 'Przejdź do logowania',
  invalidToken: 'Twój link do resetowania hasła nie jest już ważny. Możesz poprosić o kolejny poniżej.',
};
